import React from 'react';
import { useThemeContext } from '../../hook/useThemeManager';
import { Container } from '@mui/material';
import { useSelector } from 'react-redux';
import { MetaTags } from '../../components/Metatags/Metatags';
import { isDrawerOpen } from '../../selectors/selectors';
import { BuzzBridgeJobDetailsContainer } from '../../components/ScreenContainer/BuzzBridgeContainer/BuzzBridgeJobDetailsContainer';

const BuzzBridgeDetails = () => {
    const drawerOpen = useSelector(isDrawerOpen);
    const { device } = useThemeContext();

    return (
        <MetaTags description={`BuzzBridge`} title={`BuzzBridge Details | Dashboard`}>
            <Container
                disableGutters
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    minHeight: '100vh',
                }}
                maxWidth={false}
                sx={{ marginLeft: device.isDesktop && drawerOpen ? 3 : 0 }}>
                <BuzzBridgeJobDetailsContainer />
            </Container>
        </MetaTags>
    );
};

export { BuzzBridgeDetails };
